import { ImportacaoDetalheList } from './components/ImportacaoDetalheList'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'

const ImportacaoDetalhePage = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ImportacaoDetalheList />
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { ImportacaoDetalhePage }
